import { render, staticRenderFns } from "./PassgerPage.vue?vue&type=template&id=ec1409da"
import script from "./PassgerPage.vue?vue&type=script&lang=js"
export * from "./PassgerPage.vue?vue&type=script&lang=js"
import style0 from "./PassgerPage.vue?vue&type=style&index=0&id=ec1409da&prod&whyscoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports